var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    {
      ref: "dropdown",
      staticClass: "dropdown-custom action-item",
      attrs: { disabled: _vm.loading, right: "" },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function() {
            return [
              _vm.loading
                ? _c("i", { staticClass: "fas fa-spinner spin" })
                : _c("i", { staticClass: "fas fa-download" }),
              _vm._v("\n    " + _vm._s(_vm.$t("button.download")) + "\n  ")
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "b-dropdown-item",
          {
            key: index,
            on: {
              click: function($event) {
                return _vm.onSelect(item)
              }
            }
          },
          [_vm._v("\n    " + _vm._s(_vm.$t(item.text)) + "\n  ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a075f00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a075f00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseDropdownFilterDownload.vue
// module id = null
// module chunks = 